$(function() {
    // Newsletter modal, load based on querystring parameter
    if (getUrlParameter("signup") === "true") {
        $("#leadform-modal").modal();
    }

    // Modals that auto-open from a querystring, configured per section.
    // See sections/querystring-modal.liquid.
    $("[data-open-param]").each(function () {
        let modal = $(this),
            value = String(modal.data("open-value"));

        if (value !== "" && getUrlParameter(modal.data("open-param")) === value) {
            modal.modal();
        }
    });

    let leadForm = $(".ego-c-form-leadform, .ego-c-form-ztr-list-modal, .ego-c-form-lead-form-request-a-demo, .ego-c-form-lead-form-equip");

    $(".ego-c-selectmenu").on("selectmenuchange", function () {
        let _this = $(this);

        if (_this.closest("form").hasClass("form-error")) {
            _this.closest("form").valid();
        }
    });

    $(leadForm).each(function (i, obj) {
        let _obj = $(obj);

        _obj.validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            ignore: [],
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');

                if (element.is("select")) {
                    error.insertAfter(element.next(".ui-selectmenu-button"))
                } else {
                    element.parent().append(error);
                }

                _obj.closest("form").addClass("form-error");
            },
            rules: {
                "leadform[first_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true
                },
                "leadform[last_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true
                },
                "leadform[email]": {
                    required: true,
                    email: true
                },
                "ztr-list-modal[first_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true
                },
                "ztr-list-modal[last_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true
                },
                "ztr-list-modal[email]": {
                    required: true,
                    email: true
                },
                "leadform[company]": {
                    required: true
                },
                "leadform[city]": {
                    required: true
                },
                "leadform[state]": {
                    required: true
                },
                "leadform[company_address]": {
                    required: true
                },
                "leadform[employee_count]": {
                    required: true
                },
                "leadform[postal]": {
                    required: true,
                    minlength: 5
                },
                "leadform[dealer]": {
                    required: true,
                },
                "leadform[business_type]": {
                    required: true,
                },
                "leadform[crew_size]": {
                    required: true,
                },
                "leadform[hear_about]": {
                    required: true,
                },
                "leadform[currently_use]": {
                    required: true,
                },
                "leadform[phone]": {
                    digits: true
                }
            },
            messages: {
                "leadform[first_name]": {
                    required: window.theme.custom.global.error.required
                },
                "ztr-list-modal[first_name]": {
                    required: window.theme.custom.global.error.required
                },
                "leadform[last_name]": {
                    required: window.theme.custom.global.error.required
                },
                "ztr-list-modal[last_name]": {
                    required: window.theme.custom.global.error.required
                },
                "leadform[email]": {
                    required: window.theme.custom.global.error.email
                },
                "leadform[city]": window.theme.custom.global.error.required,
                "ztr-list-modal[email]": {
                    required: window.theme.custom.global.error.email
                },
                "leadform[company]": window.theme.custom.global.error.required,
                "leadform[company_address]": window.theme.custom.global.error.required,
                "leadform[employee_count]": window.theme.custom.global.error.option,
                "leadform[postal]": window.theme.custom.global.error.required,
                "leadform[dealer]": window.theme.custom.global.error.option,
                "leadform[phone]": {
                    required: window.theme.custom.global.error.required,
                    minlength: window.theme.custom.global.error.password_min_length,
                    digits: window.theme.custom.global.error.please_enter_only_digits
                },
                "leadform[business_type]": window.theme.custom.global.error.option,
                "leadform[crew_size]": window.theme.custom.global.error.option,
                "leadform[currently_use]": window.theme.custom.global.error.option,
                "leadform[hear_about]": window.theme.custom.global.error.option,
                "leadform[state]": window.theme.custom.global.error.option
            },
            submitHandler: function (form) {
                loadingMask("show");

                let formType = "";

                switch (_obj.attr("id")) {
                    case "ego-c-form-ztr-list-modal":
                        formType = "ego-c-form-ztr-list-modal";
                        break;
                    case "ego-c-form-lead-form-request-a-demo":
                        formType = "ego-c-form-lead-form-request-a-demo";
                        break;
                    case "ego-c-form-lead-form-equip":
                        // Check for at least one checkbox
                        if ($(".seminar-time-checkbox:checked").length === 0) {
                            alert("Please select at least one Tech Talk.");
                            loadingMask("hide");
                            return false;
                        }
                        formType = "ego-c-form-lead-form-equip";
                        break;
                    default:
                        formType = "ego-c-form-leadform";
                        break;
                }

                hubspotSubmission(form, _obj, formType, _obj.attr("type"));

                return false;
            }
        });
    });

    function hubspotSubmission(form, formId, formType, altId) {
        let equipSeminarTimes = { text: "", items: [] };

        if (formType === "ego-c-form-lead-form-equip") {
            // --- Reusable formatters (ET) ---
            const tz = "America/New_York";
            const fmtMMDD = new Intl.DateTimeFormat("en-US", { timeZone: tz, month: "2-digit", day: "2-digit" });
            const fmtNumParts = new Intl.DateTimeFormat("en-US", {
                timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
                hour: "2-digit", minute: "2-digit", hour12: true
            });
            const fmtWeekday = new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "long" });
            const fmtMonthLong = new Intl.DateTimeFormat("en-US", { timeZone: tz, month: "long" });

            const partsToObj = dt =>
               fmtNumParts.formatToParts(dt).reduce((a, p) => ((a[p.type] = p.value), a), {});

            const ordinal = n =>
               (n % 100 >= 11 && n % 100 <= 13) ? `${n}th` :
                  `${n}${["th","st","nd","rd"][n % 10] || "th"}`;

            const entries = [];
            const items = [];

            $(".seminar-time-checkbox:checked").each(function (_, obj) {
                const $cb = $(obj);

                // Titles
                const seminarTitle = $cb.closest(".multicolumn__column").find(".h5").first().text().trim();
                const seminarTitleShortRaw = seminarTitle.split(/[:：]/, 1)[0].trim();
                const seminarTitleShortLower = seminarTitleShortRaw.toLowerCase();

                // Description
                const description = $cb.closest(".multicolumn__column").find("p").first().text().trim();

                // Date/time (ISO like "2025-10-22T14:30:00Z")
                const iso = $cb.val() || "";
                const dt = new Date(iso);

                // Summary date: MM/DD (ET)
                const mmdd = fmtMMDD.format(dt);

                // Start time: "MM/DD/YYYY hh:mm AM" (ET)
                const p = partsToObj(dt);
                const startTime = `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute} ${p.dayPeriod}`;

                // End time: start + 15 minutes (ET)
                const addMinutes = (d, m) => new Date(d.getTime() + m * 60000);
                const pEnd = partsToObj(addMinutes(dt, 15));
                const endTime = `${pEnd.month}/${pEnd.day}/${pEnd.year} ${pEnd.hour}:${pEnd.minute} ${pEnd.dayPeriod}`;

                // Full time: "Wednesday, October 22nd at 10:30 am" (ET)
                const weekday = fmtWeekday.format(dt);
                const monthLong = fmtMonthLong.format(dt);
                const dayNum = Number(p.day);
                const fullTime = `${weekday}, ${monthLong} ${ordinal(dayNum)} at ${String(Number(p.hour))}:${p.minute} ${(p.dayPeriod || "").toLowerCase()}`;

                // Outputs
                entries.push(`${seminarTitleShortLower} (${mmdd})`);
                items.push({
                    title: seminarTitle,
                    seminarTitleShort: seminarTitleShortRaw,
                    startTime,           // "MM/DD/YYYY hh:mm AM" (ET)
                    endTime,             // start + 15 minutes (ET)
                    fullTime,            // "Wednesday, October 22nd at 10:30 am" (ET)
                    timezone: tz,
                    description
                });
            });

            equipSeminarTimes = { text: entries.join(", "), items };
        }

        let firstName = titleCase(formId.find("#leadform_first_name-" + altId).val());
        let lastName = titleCase(formId.find("#leadform_last_name-" + altId).val());
        let email = formId.find("#leadform_email-" + altId).val().toLowerCase();
        let company = formId.find("#leadform_company-" + altId).val();
        let companyAddress = formId.find("#leadform_company-address-" + altId).val();
        let city = formId.find("#leadform_city-" + altId).val();
        let state = formId.find("#leadform_state-" + altId).val();
        let numberOfEmployees = formId.find("#leadform_employee_count-" + altId).val();
        let postal = formId.find("#leadform_postal-" + altId).val();
        let phone = formId.find("#leadform_phone-" + altId).val();
        let crewSize = formId.find("#leadform_crew_size-" + altId).val();
        let currentlyUse = formId.find("#leadform_currently_use-" + altId).val();
        let hearAbout = formId.find("#leadform_hear_about-" + altId).val();
        let equipQuestions = formId.find("#leadform_question_on_cordless-" + altId).val();
        let hutkCookie = getCookie('hubspotutk');

        let businessType = "dealer"; //default to dealer for the become a dealer forms. Overwrite below if needed based off of form type
        let businessTypeDemo = "";
        let businessTypeDemoOther = "";

        /**********************************************/
        /* Double check this when a new form is added */
        /**********************************************/
        if (formId.attr("type") === "lead-form" ||
           formId.attr("type") === "lead-form-modal" ||
           formId.attr("type") === "lead-form-blog-modal" ||
           formId.attr("type") === "lead-form-equip") {
            businessType = formId.find("#leadform_business_type-" + altId).val();
        } else if (formId.attr("type") === "lead-form-request-a-demo") {
            //mapping rules
            const businessTypeMap = {
                dealer: "dealer",
                distributor_retailer: "other",
                landscaper: "landscaper",
                media_agency: "other",
                school_university: "groundskeeper",
                golf_course: "golf",
                tree_service: "landscaper",
                contractor: "landscaper",
                government: "government",
                education: "education",
                rental: "other",
                other: "other",
            };

            // grab the form’s current value (one of the keys)
            businessTypeDemo = formId.find("#leadform_business_type-" + altId).val();

            // map it to your desired value (fallback to "other")
            businessType = businessTypeMap[businessTypeDemo] || "";
        }

        let formData = {
            "fields": [
                {
                    "name": "firstname",
                    "value": firstName ? firstName : ""
                },
                {
                    "name": "lastname",
                    "value": lastName ? lastName : ""
                },
                {
                    "name": "email",
                    "value": email ? email : ""
                }
            ],
            "context": {
                "pageUri": window.location.href,
                "pageName": $("meta[property='og:title']").attr('content')
            }
        }

        if (locationInfo.IpAddress && locationInfo.IpAddress !== "N/A") {
            formData.context["ipAddress"] = locationInfo.IpAddress;
        }

        if (hutkCookie && hutkCookie.length) {
            formData.context["hutk"] = hutkCookie;
        }

        if (postal && postal.length) {
            formData.fields.push({"name": "zip", "value": postal});
        }

        if (phone && phone.length) {
            phone = phone.replace(/\D/g, ''); //strips all non numberic characters and combines numeric
            formData.fields.push({"name": "phone", "value": phone});
        }

        formData.fields.push({"name": "hs_language", "value": Shopify.locale});

        if (numberOfEmployees && numberOfEmployees.length) {
            formData.fields.push({"name": "numemployees", "value": numberOfEmployees});
        }

        if (businessType && businessType.length) {
            formData.fields.push({"name": "ego_commercial_business_type", "value": businessType});
        }

        if (businessTypeDemo && businessTypeDemo.length) {
            formData.fields.push({"name": "ego_commercial_demo_business_type", "value": businessTypeDemo});
        }

        if (businessTypeDemo && businessTypeDemo.length) {
            formData.fields.push({"name": "ego_commercial_business_type_other", "value": businessTypeDemoOther});
        }

        if (company && company.length) {
            formData.fields.push({"name": "company", "value": company});
        }

        if (companyAddress && companyAddress.length) {
            formData.fields.push({"name": "address", "value": companyAddress});
        }

        if (city && city.length) {
            formData.fields.push({"name": "city", "value": city});
        }

        if (state && state.length) {
            formData.fields.push({"name": "state", "value": state});
        }

        if (crewSize && crewSize.length) {
            formData.fields.push({"name": "ego_commercial_demo_crew_size", "value": crewSize});
        }

        if (currentlyUse && currentlyUse.length) {
            formData.fields.push({"name": "ego_commercial_demo_currently_use", "value": currentlyUse});
        }

        if (hearAbout && hearAbout.length) {
            formData.fields.push({"name": "ego_commercial_demo_hear_about", "value": hearAbout});
        }

        if (equipSeminarTimes && equipSeminarTimes.text && equipSeminarTimes.text.length) {
            formData.fields.push({"name": "ego_commercial_equip_seminar", "value": equipSeminarTimes.text});
        }

        if (equipQuestions && equipQuestions.length) {
            formData.fields.push({"name": "ego_commercial_equip_questions", "value": equipQuestions});
        }

        formData.fields.push({"name": "form_url", "value": window.location.origin + window.location.pathname});

        let subscribeDL = false;
        let formTypeDL = "";
        let formDataDL = {};

        switch (altId) {
            case "lead-form-modal": // global modal form
                subscribeDL = true;
                formTypeDL = "newsletter-modal";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            case "lead-form": // global form
                subscribeDL = true;
                formTypeDL = "newsletter-body";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            case "lead-form-become-a-dealer-modal": // become a dealer modal form
            case "lead-form-become-a-dealer": //become a dealer form
                subscribeDL = true;
                formTypeDL = "become-dealer";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            case "ztr-list-modal": //ztr modal form
                subscribeDL = true;
                formTypeDL = "product-information";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'product_sku': "ztr",
                    'product_category': "ztr"
                }

                formData.fields.push({"name": "product_information_sku", "value": "ztr"});
                break;
            case "lead-form-blog-modal": //modal blog
                subscribeDL = true;
                formTypeDL = "pro-talk";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            case "lead-form-request-a-demo": //demo
                subscribeDL = formId.find("#leadform_marketing-" + altId).is(":checked");
                formTypeDL = "demo_request";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            case "lead-form-equip":
                subscribeDL = formId.find("#leadform_marketing-" + altId).is(":checked");
                formTypeDL = "equip_seminar";

                formDataDL = {
                    'subscribe': subscribeDL,
                    'type': formTypeDL,
                    'business': businessType
                }
                break;
            default:
                errorNotify("EGO - Form Id Not Found: ", formType);
                break;
        }

        formData.fields.push({"name": "subscribe", "value": subscribeDL});
        formData = JSON.stringify(formData);

        $.ajax({
            url: $(form).attr('action'),
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            headers: {
                "accept": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            data: formData
        })
           .done(function (data) {
               loadingMask("hide");
               window.dataLayer.push({
                   'event': 'FormSubmitSuccess',
                   'form_data': formDataDL
               });

               equipATC(equipSeminarTimes);

               formId.closest(".ego-c-form").find(".ego-c-form-initial").fadeOut(function () {
                   formId.closest(".ego-c-form").find(".ego-c-form-success").fadeIn();
               });
           })
           .fail(function (error) {
               loadingMask("hide");
               if (JSON.parse(error.responseText).errors[0].errorType === "INVALID_EMAIL") {
                   errors = {email: window.theme.custom.global.error.email};
                   formId.validate().showErrors(errors);
               } else {
                   alert(window.theme.custom.global.error.generic_error)
                   errorNotify(error, $(form).attr('action'));
               }
           });
    }

    function equipATC(_equipSeminarTimes) {
        const $wrap = $(".ego-c-form-success-seminar");

        // clear anything that might already be there
        $wrap.empty();

        if (_equipSeminarTimes?.items?.length) {
            _equipSeminarTimes.items.forEach((item) => {
                $wrap.append(`
                  <h3 class="h5">${item.title}</h3>
                  <p>${item.fullTime}</p>
                  <div title="Add to Calendar" class="addeventatc">
                    Add to Calendar
                    <span class="start">${item.startTime}</span>
                    <span class="end">${item.endTime}</span>
                    <span class="timezone">${item.timezone}</span>
                    <span class="title">EGO Commercial booth #1134--${item.title}</span>
                    <span class="description">EGO Commercial booth #1134--${item.title}<br><br>${item.description || ""}</span>
                    <span class="location">Kentucky Exposition Center, Louisville, KY</span>
                  </div>
                `);
            });

            // re-init AddEvent widget if present
            if (window.addeventatc && typeof window.addeventatc.refresh === "function") {
                window.addeventatc.refresh();
            }
        }
    }
});